module.exports = __webpack_public_path__ + "static/media/LandingIntegrate.f40a6815.svg";